import {Component, Inject, OnInit} from '@angular/core';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import { ReportingServiceService } from 'src/app/shared/services/reporting-service.service';
import { MatSnackBar } from "@angular/material/snack-bar";
import { constants } from 'src/app/shared/common/contants';
import { AsignUserRoleService } from 'src/app/shared/services/asign-user-role.service';
import { EtlService } from 'src/app/user/vault-data-migration-etl/etl.service';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import {MigrationConfigComponentServices} from 'src/app/shared/services/Migrationconfiguration';
import { Actionbutton } from 'src/app/shared/common/Actionbutton';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CustomCheckBoxButton } from 'src/app/shared/common/checkBoxButton';
import { DeleteAndcheckboxComponent } from 'src/app/shared/common/deleteAndcheckButton'


export interface checkinListDialogData {
  edata: any;
  screen:any;
  page: any;
  columns: any;
  remarksData: any;
  childId: any;

}

@Component({
    selector: 'app-verify-mapping',
    templateUrl: './verify-mapping.component.html',
    styleUrls: ['./verify-mapping.component.scss'],
    standalone: false
})



export class VerifyMappingComponent implements OnInit {


  constructor(public dialogref: MatDialogRef<VerifyMappingComponent>,private spinner:NgxUiLoaderService,private localStorageSettings: LocalStorageSettingsService,private snackbar: MatSnackBar,private constants: constants,private service:EtlService,private migrationconfigservices: MigrationConfigComponentServices,@Inject(MAT_DIALOG_DATA) public data: checkinListDialogData) {   }
      
    
     
      backgroundColorButton = '';
      backgroundColorScreen
      buttonColor
      selectedGrid ='new'
      s3Path
      columnDefsExtractTemp
      paginationPageSize
      paginationNumberFormatter
      pagesize
      totalpages
      currentpage
      gridAPIValidation
      RuntotalPages1
      RuncurrentPage1
      RunpageSize1
      RunlastPage1
      RunnextPagePlusOne1
      RunnextPage1
      RunpageSize
      value
      selectedrows:any = []
      selectedattributes:any = []
      defaultColDef 
      CornerHeaderName
      components = {
        buttonRenderer: DeleteAndcheckboxComponent,
      }
      reverifyStage: boolean = false;
 

      
            

  
      ngOnInit(): void {
        this.backgroundColorButton = this.localStorageSettings.getSettings('ColorA');

       console.log(this.data)
       this.selectedattributes = this.data.edata
       this.CornerHeaderName = this.data.screen;

        if (this.CornerHeaderName === 'Verify Stage') {
           this.reverifyStage = true; 
        }


        this.columnDefsExtractTemp = [
          {
            headerName: 'Select', 
            filter: false, 
            pinned:'left',
            lockPinned:true,
            cellRenderer: 'buttonRenderer',      
            cellRendererParams: {
              check: this.checkIcon.bind(this)
            }, width: 100,
            animateRows: true
          },
          {
            headerName: 'Description',
            headerTooltip: 'Description',
            tooltipValueGetter: (params) => 'Description : ' + params.value,
            field: 'remarks',
            filter: 'agTextColumnFilter',
            width: 180,
            animateRows: true
          },
          {
            headerName: 'Set Id',
            headerTooltip: 'Set Id',
            tooltipValueGetter: (params) => 'Set Name : ' + params.value,
            field: 'setid',
            filter: 'agTextColumnFilter',
            width: 130,
            animateRows: true

          },
          {
            headerName: 'Migration Id',
            headerTooltip: 'Migration Id',
            tooltipValueGetter: (params) => 'Migration Id : ' + params.value,
            field: 'migrationid',
            filter: 'agTextColumnFilter',
            width: 180,
            animateRows: true
          },
          {
            headerName: 'Created By',
            headerTooltip: 'createdBy',
            tooltipValueGetter: (params) => 'createdBy : ' + params.value,
            field: 'createdBy',
            filter: 'agTextColumnFilter',
            width: 180,
            animateRows: true
          },
          
          {
            headerName: 'Status',
            headerTooltip: 'status',
            tooltipValueGetter: (params) => 'status : ' + params.value,
            field: 'status',
            filter: 'agTextColumnFilter',
            width: 180,
            animateRows: true,
            cellStyle: function (params) {
              if (params.value == 'Yes') {
                return { color: 'green' };
              } else {
                return { color: 'red' };
              }
            }
          }
          
          
        ]
        this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
      sortable: true,
      resizable: true,
      filter: true
    };
  
    
        this.paginationPageSize = this.constants.pagesize;
      }

      onBtExport(){
        this.gridAPIValidation.exportDataAsCsv();
      }


      cellClickedObjects(params){
        this.spinner.start()
        this.gridAPIValidation = params.api;
        this.gridAPIValidation.setGridOption('rowData', [])
      
        this.migrationconfigservices.retrivemappingtestbedforattribute().subscribe(res=>{
          console.log("----")
           console.log(res)
            this.gridAPIValidation.setGridOption('rowData', res);
            
        });

        this.spinner.stop();
      }


      onRunSearchChange(searchValue: number) {
        this.gridAPIValidation.paginationGoToPage(searchValue - 1);
      }
    
      // below function is for changing the no of rows per page
      onRunPageSizeChanged(newPageSize) {
        console.log(this.RunpageSize)
        var value = this.RunpageSize1;
        this.gridAPIValidation.setGridOption('paginationPageSize', Number(value));
      }
      
      

      onRunBtNext1() {
        console.log("next")
        this.gridAPIValidation.paginationGoToNextPage();
      }
    
      // below function for going to previous page
      onRunBtPrevious1() {
        console.log("previous")
        this.gridAPIValidation.paginationGoToPreviousPage();
      }
    
      // below function for going to first page
      onRunBtFirst1() {
        this.gridAPIValidation.paginationGoToFirstPage();
      }
    
      // below function for going to last page
      onRunBtLast1() {
        this.gridAPIValidation.paginationGoToLastPage();
      }
       
    
  
    
      onloadPaginationChanged1(){
        if (this.gridAPIValidation) {
          this.RunlastPage1 = this.gridAPIValidation.paginationIsLastPageFound();
          this.RuncurrentPage1 = this.gridAPIValidation.paginationGetCurrentPage() + 1
          this.RunnextPage1 = this.gridAPIValidation.paginationGetCurrentPage() + 1 + 1
          this.RunnextPagePlusOne1 = this.gridAPIValidation.paginationGetCurrentPage() + 1 + 1 + 1
          this.RuntotalPages1 = this.gridAPIValidation.paginationGetTotalPages()
        }
      }
    
    

  

      checkIcon(e) {
    const id = e.rowData.mappingtestbedid;
    const index = this.selectedrows.findIndex(row => row.mappingtestbedid === id);
    if (index > -1) {
        // If already exists, remove it
        this.selectedrows.splice(index, 1);
    } else {
        // Otherwise, add it
        this.selectedrows.push(e.rowData);
    }
    console.log(this.selectedrows);
    }
  
      switch(){

      }

      
  
      cancel(){
        this.dialogref.close();
      }


     create() {
  if (this.selectedrows.length === 0) {
    this.snackbar.open("Select at least one Test Bed", "OK", { duration: 5000 });
    return;
  }

  if (this.selectedrows.length > 1) {
    this.snackbar.open("Select only one Test Bed", "OK", { duration: 5000 });
    return;
  }

  const mappingtestbedid = this.selectedrows[0].mappingtestbedid;

  console.log(this.selectedattributes)

  if (!Array.isArray(this.selectedattributes) || this.selectedattributes.length === 0) {
  this.snackbar.open("No attributes selected", "OK", { duration: 5000 });
  return;
}

this.spinner.start()
let attributesIds;

const reverifyStage = this.reverifyStage ? 'Yes' : 'No';
if(this.CornerHeaderName != 'Verify Stage'){
attributesIds = this.selectedattributes
  .map(attr => attr.mappingAttributesId)
  .join(',');
}else{
  attributesIds = this.selectedattributes
  .map(attr => attr.id)
  .join(',');
  

}


  console.log("Test Bed ID:", mappingtestbedid);
  console.log("Attribute IDs:", attributesIds);
  console.log('reverifyStage:', reverifyStage);

  // Uncomment when ready to use the service

  if(this.CornerHeaderName != 'Verify Stage'){
  this.migrationconfigservices.insertintotestbedexecution(mappingtestbedid, attributesIds,this.localStorageSettings.getSettings('WorkspaceId'),0,reverifyStage)
    .subscribe(res => {
      console.log(res)
      this.snackbar.open(res.data, "OK", { duration: 5000 });
      this.spinner.stop();
    this.dialogref.close();
    });
  }else{
    this.migrationconfigservices.insertintotestbedexecution(mappingtestbedid, attributesIds,this.localStorageSettings.getSettings('WorkspaceId'),1,reverifyStage)
    .subscribe(res => {
      console.log(res)
      this.snackbar.open(res.data, "OK", { duration: 5000 });
      this.spinner.stop();
    this.dialogref.close();
    });
  }
    
}

  
  
     
  
  
  
  
  
  
     
  
  
}

